import { createStore } from "vuex";

export default createStore({
  state: {
    message: "Hello world!",
  },
  getters: {},
  mutations: {},
  actions: {},
  modules: {},
});
